import ControlOptions from "slotworks/smart-ui/options/control-options";
import AbstractNumberInputControl from "../abstract/abstract-number-input-control";

export default class CustomAutoplayCountInputControl extends AbstractNumberInputControl {

    public updateOptions(options: ControlOptions) {
        if (!this.setupData) {

            if (options.autoplays.getMin() !== 0) {
                options.autoplays.values.unshift(0);
            }

            this.setMinMaxRange(options.autoplays.getMin(), options.autoplays.getMax());

            this.input.setDefaults(this.min.toString());
            this.setupData = true;
        }

        this.input.setVisible(options.customAutoplayCountSelected);

        if (options.customAutoplayCountSelected) {
            this.input.focus();

            if (options.autoplays.currentValue > 0) {
                this.resetValue();
            }
        }

        super.updateOptions(options);
    }

    protected onChangeHandler() {
        const validatedNumber = this.getValidatedInt();

        if (validatedNumber >= 0) {
            const options = new ControlOptions();

            options.autoplays.currentValue = validatedNumber;
            options.customAutoplayCountSelected = false;

            this.onChange.dispatch(options);
        }
    }

    private resetValue() {
        this.input.setText("");
    }
}
